import { render } from "./gym.vue?vue&type=template&id=142e2d68"
import script from "./gym.vue?vue&type=script&lang=js"
export * from "./gym.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/mixitweb-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__